import React from 'react';
import { Clock } from 'react-feather';

interface ITutorialCardProps {
  title: string;
  description: string;
  category: string;
  duration: string;
  thumbnail: string;
  onClick?: () => void;
}

const TutorialCard: React.FC<ITutorialCardProps> = ({
  title,
  description,
  category,
  duration,
  thumbnail,
  onClick
}) => {
  return (
    <div className="kh-tutorial-card" onClick={onClick}>
      <div className="kh-tutorial-card__thumbnail">
        <img src={thumbnail} alt={title} />
      </div>
      <div className="kh-tutorial-card__content">
        <div className="kh-tutorial-card__meta">
          <span className="kh-tutorial-card__category">{category}</span>
          <span className="kh-tutorial-card__duration">
            <Clock size={14} /> {duration}
          </span>
        </div>
        <h3 className="kh-tutorial-card__title">{title}</h3>
        <p className="kh-tutorial-card__description">{description}</p>
      </div>
    </div>
  );
};

export default TutorialCard;
